/**
 * Validated environment access. Fail loud at boot if a required var is missing
 * rather than producing confusing runtime errors deep in a query.
 */
const required = (key: keyof ImportMetaEnv): string => {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(
      `[env] Missing required environment variable: ${key}. ` +
        `Copy .env.example to .env.local and fill it in.`,
    );
  }
  return value;
};

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL'),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY'),
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  // GIPHY (Tenor shut down June 30). Falls back to a working public key so the
  // picker works out of the box; override with VITE_GIPHY_KEY in production.
  giphyKey: import.meta.env.VITE_GIPHY_KEY ?? 'TxKNukjrIEoWtD2wBAnql9qWrbl0xdnW',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
